import React from 'react'
import { Container } from 'react-bootstrap'

const ProjectDetail2 = () => {
  return (
   <Container fluid className='project-section'>
    <div className='project-photo'>
        <div>
        <img className='img-fluid' src="https://i.ibb.co/t3vwnwZ/5.png" alt="5" border="0"/>
        </div>
        <div >
        <img className='img-fluid' src="https://i.ibb.co/LgtmvJD/8.png" alt="8" border="0"/>
        </div>
        <div >
        <img className='img-fluid' src="https://i.ibb.co/25Pq2Q6/7.png" alt="7" border="0"/>
        </div>
       
    </div>

    <div className='my-5 w-75 mx-auto text-white '>
               <h1>Project Description</h1>
               <p>This is a Unique Website of A indivudual service Provider of event manager who manages event like wedding ceremony,Birthday ceremony,Valentine's day and many more User can add and Delete any Review they </p>
               <ul className='text-strat'>
                 <li>This is a User Friendly </li>
                 <li>Secure User Authentication </li> 
                 <li>MongoDb is Used To save all the Review that used gave to any service</li> 
                 <li>React Hot Toast Is Used For Assuring User Of Any Task</li>
                 <li>After Logging in User can add Any review</li>
                 <li>user can also delete their </li>
                 <li>Private Route Is used to secure resist unwanted people</li>
               </ul>
               <div>
                <a className='btn btn-primary mx-1' target={"_blank"} href="https://the-urban-luxary.web.app/">Live Site</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/service-review-client">Client Side Link</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/master-programming-server">Server Side Link</a>
               </div>
    </div>
              

   </Container>
  )
}

export default ProjectDetail2